import {adsenseSettings} from '../../shared/adsense';
export const adsenseConfig=adsenseSettings(import.meta.env);
